import { useNavigate } from 'react-router-dom';
import { Amplify, Auth } from 'aws-amplify';
import awsExportsDWP from '../../aws-exports_DWP';

Amplify.configure(awsExportsDWP)

function MainComponent({ handleLoading }) {

    document.title = "NEC DWP| ファーストコンタクトセンター";
    const navigate = useNavigate();

    const login = async () => {
        handleLoading(true);

        localStorage.removeItem('userId');
        localStorage.removeItem('sfUserId');
        localStorage.removeItem('email');
        try {
            await Auth.federatedSignIn(
                { customProvider: awsExportsDWP.custom_provider }
            );
        } catch (err) {
            navigate("/fcc_login");
            handleLoading(false);
            return;
        }


    }

    try {
        login()
    } catch (err) {
        return false
    }

    return (
        <div>
            <div className="header-utility">
                <div className="header-utility-inner">
                    <ul className="header-utility-list sub">
                    </ul>
                </div>
            </div>
            <main className="site-main">
                <section className="sct-primary">
                    <div className="mod-hdg-l1">
                        <div className="inner">
                            <h1 className="hdg">NEC DWP</h1>
                            <span className="sub of-top">ログイン</span>
                        </div>
                    </div>
                    <div className="str-outer">
                        <div className="str-inner">
                            <div className="mod-tbl-form mb-30">
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
}


export default MainComponent;